import { fetchFamilyInfo } from '../../family/familyInfoApi';
import type { FamilyMemberCandidate } from './retirementAllowanceTypes';

export async function fetchRetirementAllowanceCandidates(email: string): Promise<{
  spouse: FamilyMemberCandidate | null;
  dependents: FamilyMemberCandidate[];
}> {
  const res = await fetchFamilyInfo(email);
  const members = res.members ?? [];
  const mapped: FamilyMemberCandidate[] = members
    .filter((m) => m.id != null && (m.fullName?.trim() ?? '') !== '')
    .map((m) => ({
      empFamilyId: m.id!,
      fullName: m.fullName?.trim() ?? '',
      relationship: (m.relationship ?? '').trim().toLowerCase(),
    }));

  const spouse = mapped.find((m) => m.relationship === 'spouse') ?? null;
  const dependents = mapped.filter((m) => m.relationship !== 'spouse');
  return { spouse, dependents };
}
